import { DefaultRouteTabs } from '@/components/_common';
import SpedDocumentDetailCard from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentDetailCard';
import SpedDocumentDetailImportInutilization from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentDetailImportInutilization';
import SpedDocumentDetailImportInvoice from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentDetailImportInvoice';
import SpedDocumentDetailImportPurchase from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentDetailImportPurchase';
import SpedDocumentFooter from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentFooter';
import SpedDocumentImportedList from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentImportedList';
import SpedDocumentSendToPlugStorage from '@/components/Fiscal/Sped/SpedDocumentDetail/SpedDocumentSendToPlugStorage';
import { useSpedDocumentDetail } from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import { SpedDocument } from '@/core/domain/sped/sped-documents/sped-documents.types';
import { useDisclosure, useRouteMatchParam, useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Row, Col, Button, Dropdown } from 'antd';
import { createContext, useContext, useState } from 'react';
import './style.less';

type SpedDocumentContextParams = {
  spedDocument?: SpedDocument;
  hasItemsPendingOrErros: boolean;
  setHasItemsPendingOrErros(value: boolean): void;
};

const SpedDocumentContext = createContext<SpedDocumentContextParams>({
  spedDocument: undefined,
  hasItemsPendingOrErros: false,
} as SpedDocumentContextParams);

export const useSpedDocumentContext = () =>
  useContext(SpedDocumentContext).spedDocument;

export const useSpedDocumentHasItemContext = (): [
  boolean,
  (value: boolean) => void,
] => {
  const { hasItemsPendingOrErros, setHasItemsPendingOrErros } =
    useContext(SpedDocumentContext);
  return [hasItemsPendingOrErros, setHasItemsPendingOrErros];
};

export default function SpedDocumentDetailPage(props: PageProps) {
  const spedDocumentId = useRouteMatchParam('id');

  const { isMobile } = useWindowSize();

  const [hasItemsPendingOrErros, setHasItemsPendingOrErros] = useState(false);

  const { data: spedDocument, isLoading } = useSpedDocumentDetail(
    Number(spedDocumentId),
  );

  const [dropdownOpened, dropdownAction] = useDisclosure();

  return (
    <SpedDocumentContext.Provider
      value={{
        spedDocument,
        hasItemsPendingOrErros,
        setHasItemsPendingOrErros,
      }}
    >
      <DefaultRouteTabs
        route={props.route.parent}
        permissions={props.route.permissions}
      >
        <SpedDocumentDetailCard
          spedDocument={spedDocument}
          loading={isLoading}
        />

        <Row gutter={[16, 16]} style={{ padding: '24px 0px' }} justify="end">
          <Col span={24} hidden={!isMobile}>
            <Dropdown
              trigger={['click']}
              className="sped-import-dropdown"
              open={dropdownOpened}
              onOpenChange={(open) =>
                open ? dropdownAction.open() : dropdownAction.close()
              }
              overlay={
                <div
                  className="sped-import-dropdown-container"
                  onClickCapture={() => {
                    dropdownAction.close();
                  }}
                >
                  <SpedDocumentDetailImportPurchase />
                  <SpedDocumentDetailImportInvoice />
                  <SpedDocumentDetailImportInutilization />
                </div>
              }
            >
              <Button type="primary" ghost block>
                Importação
              </Button>
            </Dropdown>
          </Col>

          <Col span={24} sm={12} md={8} xl={5} hidden={isMobile}>
            <SpedDocumentDetailImportPurchase />
          </Col>

          <Col span={24} sm={12} md={8} xl={5} hidden={isMobile}>
            <SpedDocumentDetailImportInvoice />
          </Col>

          <Col span={24} md={8} xl={5} hidden={isMobile}>
            <SpedDocumentDetailImportInutilization />
          </Col>

          <SpedDocumentSendToPlugStorage />
        </Row>

        <SpedDocumentImportedList />

        <SpedDocumentFooter />
      </DefaultRouteTabs>
    </SpedDocumentContext.Provider>
  );
}
